<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal title="退款取消" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="handleCancel" :maskClosable="false">
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="state.loading" @click="onFormSubmit">立即取消</a-button>
    </template>
    <a-spin :spinning="state.loading">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
        <a-form-item label="主体名称">
          {{ props.detailData.full_name }}
        </a-form-item>
        <a-form-item label="代理商">
          {{ props.detailData.nickname }}
        </a-form-item>
        <a-form-item label="当前状态">
          <p>
            <a-tag color="blue" v-if="props.detailData.status == 1">排队中</a-tag>
            <a-tag color="green" v-if="props.detailData.status == 2">免单中</a-tag>
            <a-tag color="gray" v-if="props.detailData.status == 3">已完成</a-tag>
            <a-tag color="gray" v-if="props.detailData.status == 4">退款取消</a-tag>
          </p>
          <p>
            已获取免单金额：<span style="color: red">{{ state.free_money }}</span>
          </p>
          <p v-for="item in state.free_coupons" :key="item.id">
            {{ item.name }}
            <a-tag color="green" v-if="item.status == 0">待使用</a-tag>
            <a-tag color="gray" v-if="item.status == 1">已使用</a-tag>
            <a-tag color="gray" v-if="item.status == 2">赠送</a-tag>
            <a-tag color="gray" v-if="item.status == 3">过期</a-tag>
            <a-tag color="gray" v-if="item.status == 4">作废</a-tag>
          </p>
        </a-form-item>
        <a-form-item label="退返现余额" name="back_money" required>
          <a-input placeholder="请输入金额" v-model:value="formState.back_money" style="width: 150px" addonAfter="元"></a-input>
        </a-form-item>
        <a-form-item label="未使用的优惠券" name="coupon_zuofei" required>
          <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.coupon_zuofei" checked-children="作废" un-checked-children="不作废"></a-switch>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
  labelCol: {
    xs: { span: 7 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 10 }
  }
}
interface state {
  loading: boolean
  free_money: string
  free_coupons: Array<any>
}
const state = reactive<state>({
  loading: false,
  free_money: '',
  free_coupons: []
})
interface formState {
  back_money: number
  coupon_zuofei: number
}
let formState = reactive<formState>({
  back_money: 0,
  coupon_zuofei: 1
})
onMounted(() => {
  queryRebate()
})
const queryRebate = () => {
  state.loading = true
  let requeryParam = {
    url: '/admin/v1/freequeue/rebate',
    method: 'post',
    data: {
      id: props.detailData.id
    }
  }
  baseService(requeryParam)
    .then((res) => {
      state.free_money = res.data.free_money
      state.free_coupons = res.data.free_coupons
    })
    .finally(() => {
      state.loading = false
    })
}

const onFormSubmit = () => {
  ruleForm.value
    .validate()
    .then(() => {
      state.loading = true
      let requeryParam = {
        url: '/admin/v1/freequeue/cancel',
        method: 'post',
        data: Object.assign({ id: props.detailData.id }, formState)
      }
      baseService(requeryParam)
        .then((res: any) => {
          state.loading = false
          message.success(res.msg)
          emit('ok')
        })
        .catch((res) => {
          state.loading = false
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    })
    .catch(() => {})
}
const handleCancel = () => {
  emit('cancel')
}
</script>

<style lang="less" scoped></style>
